import React from 'react'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { renderApp } from '@inertiaui/modal-react'
import { ThemeProvider } from 'next-themes'
import { AppLayout } from '@/layouts/AppLayout'
import './application.css'

createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, any>
    const page = pages[`../pages/${name}.tsx`]
    // Auth pages use their own layout (AuthLayout) — don't apply AppLayout
    if (!name.startsWith('Auth/')) {
      page.default.layout ??= (children: React.ReactNode) => (
        <AppLayout>{children}</AppLayout>
      )
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
        {renderApp(App, props)}
      </ThemeProvider>
    )
  },
})
